export enum FlowType {
  Register = 1,
  Apply = 2,
  CoApply = 3
}
